package uz.ferro.erp.feature.address.model

import kotlinx.serialization.Serializable

@Serializable
data class GeoAddressDto(
    val id: Long? = null
)